import { type SizeType } from './interfaces';

export const SIZES: Record<
  SizeType,
  { height: number | string; width: number | string }
> = {
  DEFAULT: { height: 'auto', width: '100%' },
  PROMOTED: { height: 186, width: 186 },
};
